import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { Finan } from './Finan';
import { store } from './store/store';
import 'animate.css';
import './index.css';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={ store }>
    <React.StrictMode>
      <Finan />
    </React.StrictMode>
  </Provider>
);
